<template>
  <div
    v-if="showCompontent"
    class="famousenterprise"
    :style="{ backgroundImage: 'url(' + moduleIconUrl + ')' }"
  >
    <div class="header">
      <div class="header_info">
        <span
          class="header_title"
          :style="{
            textShadow: `0px 2px 8px ${buttonColor}`,
          }"
          >{{ componentConfig.title }}</span
        >
        <span
          class="header_desc"
          :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
          >{{ componentConfig.subtitle }}</span
        >
      </div>
    </div>
    <Empty v-if="!loading && advJobList?.length === 0" text="暂无公司推荐啦" />
    <template v-else>
      <!--广告位 存在展示-->
      <div class="adv" v-if="advJobList.length == 0 && loading">
        <div v-for="(item, index) in 2" :key="index" class="item empty adEmpty">
          <div class="skeleton"></div>
        </div>
      </div>
      <div v-else class="adv">
        <div
          v-for="(aitem, aindex) in advJobList"
          :key="aindex"
          class="item sensors_exposure"
          sensorsname="CompanyShortExposure"
          :sensorsdata="$base.getCompanyShortExposureData(aitem, aindex)"
          @click="handleClick(aitem, aindex)"
        >
          <img :src="aitem.companyLogo" alt="" />
          <div class="right">
            <div class="comname">{{ aitem.companyName }}</div>
            <div class="comtype">{{ aitem.companyTypeString }}</div>
            <div class="comsize">{{ aitem.companySizeString }}</div>
          </div>
        </div>
      </div>
      <!---->
      <div class="mdl">
        <div
          class="logoLists empty"
          v-if="swiperJobList.length == 0 && loading"
        >
          <div class="swiper-slide" v-for="(eitem, eindex) in 5" :key="eindex">
            <div class="item empty">
              <div class="skeleton"></div>
            </div>
          </div>
        </div>
        <swiper
          ref="mySwiper"
          class="logoLists swiperCon"
          :options="swiperOptions"
          v-else
        >
          <swiper-slide
            v-for="(image, kindex) in swiperJobList"
            :key="kindex"
            class="swiper-slide"
          >
            <div
              :key="kindex"
              class="item sensors_exposure"
              sensorsname="CompanyShortExposure"
              :sensorsdata="
                $base.getCompanyShortExposureData(
                  image,
                  kindex + advJobList?.length
                )
              "
              @click="handleClick(image, kindex)"
            >
              <img :src="image.companyLogo" alt="" />
              <div class="comname">{{ image.companyName }}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </template>
  </div>
</template>

<script>
import Empty from "../common/EmptyData.vue";
import { mapState } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "EnterpriseScrollview",
  components: {
    Swiper,
    SwiperSlide,
    Empty,
  },
  props: {
    pageConfig: {
      type: Object,
      default: () => {},
    },
    componentConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showCompontent: true,
      advJobList: [], //广告职位,>=2展示大卡样式,反之小卡轮播
      swiperJobList: [], // 小卡轮播列表
      loading: false, //接口是否响应完成
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        initialSlide: 0,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        speed: 200,
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 6,
      },
      requestId: "",
      jobOrCompanyIdList: [],
      pageNum: 1,
    };
  },
  computed: {
    ...mapState(["commonStore","resumeStore"]),
    startTime() {
      return this.swiperJobList && this.swiperJobList.length > 0 ? 5000 : 0;
    },
    backgroundConfigDTO(){
      return this.componentConfig.backgroundConfigDTO
    },
    buttonColor(){
      return this.backgroundConfigDTO?.buttonColor||this.pageConfig.buttonColor
    },
    moduleIconUrl(){
      if(this.commonStore.isForPC){
        return this.backgroundConfigDTO?.moduleIconPcUrl||this.pageConfig.moduleIconPcUrl
      }else{
        return this.backgroundConfigDTO?.moduleIconUrl||this.pageConfig.moduleIconUrl
      }
    }
  },
  watch: {
    "commonStore.currentAreaCode": {
      handler(newVal) {
        if (!newVal) return;
        this.loading = false;
        this.pageNum = 1;
        this.advJobList = [];
        this.swiperJobList = [];
        this.requestId = "";
        this.jobOrCompanyIdList = [];
        this.getActivityCompanyList();
      },
      immediate: false,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.getActivityCompanyList();
    },
    // 获取公司列表
    async getActivityCompanyList() {
      this.loading = true;
      const params = {
        componentId: this.componentConfig?.id,
        cityCode: this.commonStore.currentAreaCode,
        funcCode: this.$route.query?.funcCode
          ? this.$route.query.funcCode
          : this.commonStore.intention?.expectFunction || "",
        requestId: this.requestId,
        jobOrCompanyIdList: this.jobOrCompanyIdList,
        pageNum: this.pageNum,
        pageSize: 50,
        workFuncStr: this.commonStore.intention?.expectFunctionString,
        expectWorkArea: this.commonStore.intention?.expectArea,
        expectIndustry: this.commonStore.intention?.expectIndustry,
        expectIndustryNew: this.commonStore.intention?.expectIndustry,
        expectMinSalary: this.commonStore.intention?.minSalary,
        expectMaxSalary: this.commonStore.intention?.maxSalary,
        busBelong: this.pageConfig.busBelong || "51job",
        seekType: this.commonStore.intention?.seekType || "",
        userIdentity:
          this.commonStore.identityType == "职场人"
            ? 0
            : this.commonStore.identityType == "在校生"
            ? 1
            : 0,
        degree:this.resumeStore.resume?.c.education[0]?.degree || '',
        major:this.resumeStore.resume?.c.education[0]?.major || ''
      };
      const property = {
        pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|colist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
        shortPageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|colist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
      };
      const res = await this.$api.activity.getActivityCompanyList(params, {
        property,
      });
      if (+res?.code == "0") {
        const {
          requestId,
          jobOrCompanyIdList,
          companyInfoList: { result = [] } = {},
        } = res.data;

        if (!result?.length && this.pageNum == 1) {
          this.showCompontent = false
          this.$store.commit('subCountJobAndCompany')
        }

        this.requestId = requestId;
        this.jobOrCompanyIdList = jobOrCompanyIdList;
        this.advJobList = result.slice(0, 2);
        this.swiperJobList = result.slice(2);
        this.swiperOptions.loop = this.swiperJobList.length > 4;
        this.loading = false;
        this.$nextTick(() => {
          this.$exposure.sensorsExposure();
        });
      } else if (+res?.code == "9" && this.pageNum == 1) {
        this.showCompontent = false
        this.$store.commit('subCountJobAndCompany')
      } else {
        this.loading = false;
      }
    },
    handleClick(item, index) {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_colist",
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        contentType: "公司",
        contentId: item.coId,
        contentRank: `${index}`,
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|colist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
        },
      });

      if (
        !["yjsM", "yjsPC"].includes(this.platform) &&
        !this.$base.checkLoginStatus(true)
      )
        return;

      if (item.topCompany && item.jumpLink) {
        this.$base.toTopCompanyDetail(item, index, true);
      } else {
        this.$base.toCompanyDetail(item, index, true);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.famousenterprise {
  padding-bottom: 24px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px 12px 0px 0px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  position: relative;
  .adapt_pc_widescreen & {
    width: 1200px;
    margin: 0 auto;
  }
  .header {
    display: flex;
    align-items: baseline;
    padding: 13px 8px 4px 8px;
    justify-content: space-between;
    .header_info {
      .header_title {
        width: 98px;
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        line-height: 30px;
        text-shadow: 0px 2px 8px #e16e69;
        margin-left: 8px;
      }
      .header_desc {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        text-shadow: 0px 2px 8px #e16e69;
        margin-left: 9px;
      }
    }
    .header_change {
      width: 74px;
      height: 25px;
      border-radius: 13px;
      color: #ffffff;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      // margin-left: 19px;
      line-height: 25px;
      .icon {
        width: 16px;
        height: 16px;
        background: url("@/assets/img/activity/change@3x.png");
        background-size: cover;
      }
      .change {
        margin-left: 2px;
      }
    }
  }

  .adv {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 8px;
    margin: 5px 8px 0 8px;

    .item {
      display: block;
      overflow: hidden;
      background-color: #ffffff;
      border-radius: 8px;
      font-size: 10px;
      font-weight: 400;
      color: #611f11;
      text-align: center;
      position: relative;
      display: flex;
      cursor: pointer;
      &.adEmpty {
        height: 86px;
        background-size: 100% 100%;
      }
      .skeleton {
        width: 100%;
        height: 100%;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0) 24%,
          rgba(255, 255, 255, 0.9) 25%,
          rgba(255, 255, 255, 0.9) 75%,
          rgba(255, 255, 255, 0) 76%,
          rgba(255, 255, 255, 0) 100%
        );
        background-size: 50% 100%;
        filter: blur(25px);
        animation: gradient 1.5s linear infinite;
      }

      img {
        width: 74px;
        height: 74px;
        box-sizing: border-box;
        border-radius: 5px;
        border: 1px solid #ebebeb;
        background: #ffffff;
        margin: 6px;
      }

      .right {
        flex: 1;
        overflow: hidden;
        margin-right: 6px;
        .comname {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #222222;
          line-height: 18px;
          text-align: center;
          font-style: normal;
          margin-top: 6px;
          // width: 74px;
          min-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          text-overflow: -webkit-ellipsis-lastline;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          text-align: left;
          word-break: break-all;
        }
        .comtype,
        .comsize {
          margin-top: 0;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #4e525a;
          line-height: 12px;
          text-align: left;
          font-style: normal;
          margin-top: 4px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .comtype {
          margin-top: 9px;
        }

        .newjobtip {
          display: inline-block;
          height: 17px;
          background: linear-gradient(270deg, #ff4c00 0%, #ff1d1d 100%);
          border-radius: 8px 8px 8px 0;
          position: absolute;
          left: 0;
          top: 0;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 17px;
          text-align: center;
          font-style: normal;
          padding: 0 6px;
        }

        .campusjobtip {
          display: inline-block;
          height: 17px;
          background: linear-gradient(270deg, #ff8900 0%, #ff7205 100%);
          border-radius: 8px 8px 8px 0;
          position: absolute;
          left: 0;
          top: 0;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 17px;
          text-align: center;
          font-style: normal;
          padding: 0 6px;
        }
      }
    }

    .empty {
      background-image: url("@/assets/img/activity/c-big.png");
      background-size: cover;
      background-color: #ffffff;
    }
  }

  .empty {
    display: flex;
    overflow: hidden;

    .swiper-slide {
      margin-right: 6px;
    }
  }

  .logoLists {
    height: 100%;
    box-sizing: border-box;
    margin: 6px 0 0 7px;

    /deep/ .van-swipe-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
    }

    .swiper-slide {
      width: 21%;
    }

    .item {
      flex: 0 0 80px;
      // height: 117px;
      overflow: hidden;
      background-color: #ffffff;
      border-radius: 8px;
      font-size: 10px;
      font-weight: 400;
      color: #611f11;
      text-align: center;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding: 6px;
      padding-bottom: 8px;

      .skeleton {
        width: 100%;
        height: 100%;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0) 24%,
          rgba(255, 255, 255, 0.9) 25%,
          rgba(255, 255, 255, 0.9) 75%,
          rgba(255, 255, 255, 0) 76%,
          rgba(255, 255, 255, 0) 100%
        );
        background-size: 50% 100%;
        filter: blur(25px);
        animation: gradient 1.5s linear infinite;
      }

      .comname {
        padding: 0 1px;
        overflow: hidden;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #222222;
        line-height: 16px;
        text-align: center;
        font-style: normal;
        margin-top: 8px;
        text-overflow: ellipsis;
        text-overflow: -webkit-ellipsis-lastline;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        text-align: left;
        word-break: break-all;
        height: 32px;
      }

      .invitenum {
        margin-top: 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 17px;
        font-style: normal;
        text-align: center;
      }

      .newjobtip {
        display: inline-block;
        height: 17px;
        background: linear-gradient(270deg, #ff4c00 0%, #ff1d1d 100%);
        border-radius: 8px 8px 8px 0;
        position: absolute;
        left: 0;
        top: 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 17px;
        text-align: center;
        font-style: normal;
        padding: 0 6px;
      }

      .campusjobtip {
        display: inline-block;
        height: 17px;
        background: linear-gradient(270deg, #ff8900 0%, #ff7205 100%);
        border-radius: 8px 8px 8px 0;
        position: absolute;
        left: 0;
        top: 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 17px;
        text-align: center;
        font-style: normal;
        padding: 0 6px;
      }
    }

    .empty {
      height: 117px;
      background-image: url("@/assets/img/activity/c-small.png");
      background-size: 100% 100%;
      background-color: #ffffff;
    }

    img {
      display: inline-block;
      width: 100%;
      height: 63px;
      border-radius: 4px;
      border: 1px solid #ebebeb;
      box-sizing: border-box;
    }
  }
}
</style>
